import { connect, Dispatch } from 'react-redux';

import { AppState } from '../../..';
import { ContractViewModel } from '@models/Contract';
import {
  lookupCustomer,
  loadBuyer,
  loadSeller,
  clearBuyer,
  clearSeller,
  saveCustomerInfo
} from '../../contract.actions';
import { CustomerInfoComponent, CustomerInfoProperties } from './customer-info.component';
import { ModalProps } from '@common/components';
import { toggleModal, getById, doAsync } from '@common/components/common.actions';

import { CustomerViewModel } from '@models/Customer';
import { getCustomerFromService } from '../../../customer/customer.actions';
import { actions } from 'react-redux-form';

/*
This is the container for the component.
This "connects" the redux and react layers by translating the state of the page into props for the component.
It also wires up the actions so the component can emit them.
*/

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: {
    buttonRef: (button: HTMLButtonElement) => void;
    next?: Function;
    currentStep: number;
    isOrderEdit?: boolean;
    isOpenContract?: boolean;
  }
): Partial<CustomerInfoProperties> {
  return {
    message: state.contract.message,
    currentStep: ownProps.currentStep,
    buttonRef: ownProps.buttonRef,
    buyerCustomer: state.contract.buyerCustomer,
    sellerCustomer: state.contract.sellerCustomer,
    sellerCoverage: state.coverageStep.sellerCoverage || state!.contract!.contractVM!.sellerCoverage,
    orderType: state.contract.orderType,
    isOrderEdit: ownProps.isOrderEdit,
    isOpenContract: state.contract.isOpenContract
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: {
    buttonRef: (button: HTMLButtonElement) => void;
    next?: Function;
    currentStep: number;
    isOrderEdit?: boolean;
  }
): Partial<CustomerInfoProperties> {
  return {
    onSaveClick: (model: ContractViewModel) => {
      dispatch(doAsync(saveCustomerInfo(model))).then(() => {
        if (ownProps.next) {
          ownProps.next();
        }
      });
    },
    customerLookup(value: string, id: number) {
      return lookupCustomer(value, id);
    },
    toggleModal: (modalProps: ModalProps) => {
      dispatch(toggleModal(modalProps));
    },
    onBuyerCustomerSelect: (model: string, value: number) => {
      dispatch(getById<CustomerViewModel>(value, getCustomerFromService)).then(customer => {
        if (!customer) {
          return;
        }
        dispatch(loadBuyer(customer, true));
      });
    },
    onSellerCustomerSelect: (model: string, value: number) => {
      dispatch(getById<CustomerViewModel>(value, getCustomerFromService)).then(customer => {
        if (!customer) {
          return;
        }
        dispatch(loadSeller(customer, true));
      });
    },
    clearBuyer: () => {
      dispatch(actions.change('customerInfoForm.buyerId', ''));
      dispatch(clearBuyer());
    },
    clearSeller: () => {
      dispatch(actions.change('customerInfoForm.sellerId', ''));
      dispatch(clearSeller());
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const CustomerInfo = connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerInfoComponent);



// WEBPACK FOOTER //
// ./src/contract/_components/customer-info/customer-info.container.ts